import React, { FC, ReactNode } from "react"

import { create } from "src/helpers/bem"

import { classnames } from "src/helpers/classnames"

import { AdvancedFormCondition } from "./AdvancedForm"

import styles from "./AdvancedFormFieldContainer.module.scss"

const bem = create(styles, "AdvancedFormFieldContainer")

export type AdvancedFormFieldContainerProps = {
  field?: string
  className?: string
  description?: string
  conditions?: AdvancedFormCondition
  children: ReactNode
}

export const AdvancedFormFieldContainer: FC<
  AdvancedFormFieldContainerProps
> = ({ field, className, conditions, description, children }) => {
  if (conditions?.display === false) {
    return <></>
  }

  return (
    <div
      className={bem(
        className,
        classnames(field, conditions?.invalid ? "invalid" : undefined),
      )}
    >
      {description && <p className={bem("description")}>{description}</p>}
      {children}
    </div>
  )
}
